export enum ReportEndpoint {
  Ihub,
  Crossroads,
}
